import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

interface OmnibarEmptyResultsProps {
  query: string;
  isFiltered: boolean;
  canSearchRecords: boolean;
  onShowAll: () => void;
  onSearchRecords: () => void;
}

export function OmnibarEmptyResults({ query, isFiltered, canSearchRecords, onShowAll, onSearchRecords }: OmnibarEmptyResultsProps) {
  const trimmedQuery = query.trim();

  return (
    <Box>
      <Typography variant="body2">{trimmedQuery ? `Ingen funktioner matcher »${trimmedQuery}«.` : 'Ingen funktioner at vise.'}</Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        {isFiltered && (
          // The omnibar closes on blur, so the search field must keep focus.
          <Button size="small" variant="outlined" onMouseDown={event => event.preventDefault()} onClick={onShowAll}>
            Vis alle resultater
          </Button>
        )}
        {canSearchRecords && trimmedQuery && (
          <Button size="small" variant="outlined" onMouseDown={event => event.preventDefault()} onClick={onSearchRecords}>
            Søg efter »{trimmedQuery}« i Fasitsøgning
          </Button>
        )}
      </Stack>
    </Box>
  );
}
